import React, { Fragment, useContext, useEffect, useState } from "react";

import { post } from "axios";
// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import {
  Container,
  DateLayer,
  DateTimeLayer,
  openLayerFn,
  closeLayerFn,
  pickerStart,
} from "../../Layout";

import { InputDiv } from "./Input";
import styled from "styled-components";
import { PostApi1953 } from "../../../modules/network/padoPost";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";

export const TargetInputLayer = (props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const saveTargetStudyResult = (studItemCd, studRslt) => {
    PostApi1953(userinfo, cfg, studItemCd, studRslt)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          props.setTargetStudyResult(studRslt);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    //목표혈압 버튼 (레이어 열기)
    $(".btn-goalset").click(function () {
      openLayerFn($(".bloodgoal-layer"));
    });
    //목표혈압 설정 레이어 닫기
    $(".bloodgoal-layer .tbns-area a").click(function () {
      closeLayerFn($(".bloodgoal-layer"));
    });
  }, []);

  return (
      <div className="blacklayer-container bloodgoal-layer">
          <div className="bl-blind"></div>
          <div className="in-layerarea nobtn">
              <div>
                  <div className="blgrn-box vertical">
                      <div className="blgr-title">목표당화혈색소 설정</div>
                      <div className="under-txt">
                          담당의사와 상담한 목표당화혈색소 수치입니다.
                      </div>

                      <ListDiv>
                          <NameDiv></NameDiv>
                          <InputData
                              type="number"
                              pattern="\d*"
                              name={"postData"}
                              id={"targetStudyResult"}
                              defaultValue={props.targetStudyResult}
                              onChange={(e) => maxLengthCheck(e, 4)}
                          />
                          <PercentI>%</PercentI>
                      </ListDiv>

                      <div className="tbns-area">
                          <a href={void 0} className="btn-round gray">
                              취소
                          </a>
                          <a
                              onClick={() =>
                                  saveTargetStudyResult(
                                      "hba1c",
                                      $("#targetStudyResult").val()
                                  )
                              }
                              className="btn-round wht"
                          >
                              확인
                          </a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
};

const ListDiv = styled.div`
  padding-bottom: 16px;
  position: relative;
  display: flex;
`;

// float:left;
const NameDiv = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
`;

// float:right;
const InputData = styled.input`
  border: 1px solid #d0d0d0;
  border-radius: 7px;
  background: #fff;
  box-sizing: border-box;
  height: 40px;
  position: relative;
  right: 0px;
  padding-right: 32px;
  padding-left: 16px;
  width: 100%;
`;

const PercentI = styled.i`
  right: 16px;
  font-size: 16px;
  color: #999;
  position: absolute;
  line-height: 40px;
`;
